import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ITradeResultDetails {
  idTrade: string;
  product: string;
  creationDate: string;
  customerName: string;
  cpf: string;
}

@Component({
  selector: 'app-trade-result-details',
  templateUrl: './trade-result-details.component.html',
  styleUrls: ['./trade-result-details.component.sass'],
})
export class TradeResultDetailsComponent {
  @Input() trade: ITradeResultDetails | null = null;
  @Output() evidenceClick = new EventEmitter<void>();
}
